(function(){
'use strict';
/* FREE Delivery promo popup — lead capture (spin wheel removed) */
try{localStorage.setItem('alx_pop','1');}catch(e){} /* retire old FIRST10 popup */

/* ===== scroll position keeper: restore scroll when user comes BACK to a page ===== */
try{
  window.addEventListener('pagehide',function(){
    try{sessionStorage.setItem('alxScroll:'+location.pathname,String(window.scrollY||0));}catch(e){}
  });
  window.addEventListener('pageshow',function(ev){
    try{
      if(ev.persisted)return; /* bfcache already restored position */
      var nav=performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];
      if(!nav||nav.type!=='back_forward')return;
      var v=sessionStorage.getItem('alxScroll:'+location.pathname);
      if(v===null)return;
      var y=parseInt(v,10);
      if(!(y>0))return;
      var tries=0;
      (function restore(){
        window.scrollTo(0,y);
        tries++;
        if(tries<6&&Math.abs((window.scrollY||0)-y)>40)setTimeout(restore,180);
      })();
    }catch(e){}
  });
}catch(e){}

function isDark(){return document.body.classList.contains('template-index')||document.documentElement.classList.contains('alx-dark');}

/* lead capture 1: cart attributes — rides into the order (guaranteed) */
function saveLeadToCart(nm,ph,em){
  try{
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Lead Name':nm,'Lead WhatsApp':ph,'Lead Email':em}})}).catch(function(){});
  }catch(e){}
}
/* lead capture 2: customer form via real navigation POST in hidden iframe (best effort) */
function saveLeadToCustomers(nm,ph,em){
  try{
    var ifr=document.createElement('iframe');ifr.name='alxLeadFrame';ifr.style.display='none';document.body.appendChild(ifr);
    var f=document.createElement('form');f.method='post';f.action='/contact';f.target='alxLeadFrame';f.style.display='none';
    function add(n,v){var i=document.createElement('input');i.type='hidden';i.name=n;i.value=v;f.appendChild(i);}
    add('form_type','customer');add('utf8','✓');
    add('contact[tags]','newsletter, free-dc-popup, '+nm.replace(/,/g,' ')+', wa-'+ph);
    add('contact[email]',em);
    document.body.appendChild(f);f.submit();
    setTimeout(function(){try{ifr.remove();f.remove();}catch(e){}},8000);
  }catch(e){}
}

function initPromo(){
  if(window.__alxPromo)return;window.__alxPromo=true;
  try{
    if(!isDark())return;
    if(localStorage.getItem('alx_lead'))return;
    setTimeout(function(){
      try{
        if(localStorage.getItem('alx_lead'))return;
        var w=document.createElement('div');w.className='alx-pop-wrap';
        w.innerHTML='<div class="alx-pop alx-spin-card">'
          +'<button class="alx-pop-x" type="button" aria-label="Close">✕</button>'
          +'<div class="alx-sp1">'
          +'<div class="alx-pop-g">🚚</div>'
          +'<h3>FREE Delivery!</h3>'
          +'<p>Enter your details and get <b>FREE Delivery</b> on orders above <b>Rs.6,000</b></p>'
          +'<input class="alx-sp-in" id="alxLdName" type="text" placeholder="Your name" autocomplete="name">'
          +'<input class="alx-sp-in" id="alxLdPhone" type="tel" placeholder="WhatsApp number (03XXXXXXXXX)" autocomplete="tel">'
          +'<input class="alx-sp-in" id="alxLdEmail" type="email" placeholder="Email address" autocomplete="email">'
          +'<div class="alx-sp-err" hidden></div>'
          +'<button type="button" class="alx-sp-go">Unlock FREE Delivery 🎉</button>'
          +'<small>🎁 Plus: FREE Travel Kit + Solution Kit with every lens order</small>'
          +'</div>'
          +'<div class="alx-sp3" hidden></div>'
          +'</div>';
        document.body.appendChild(w);
        requestAnimationFrame(function(){requestAnimationFrame(function(){w.classList.add('alx-on');});});
        var s1=w.querySelector('.alx-sp1'),s3=w.querySelector('.alx-sp3');
        function close(){w.classList.remove('alx-on');setTimeout(function(){w.remove();},450);}
        w.querySelector('.alx-pop-x').addEventListener('click',close);
        w.addEventListener('click',function(e){if(e.target===w)close();});
        w.querySelector('.alx-sp-go').addEventListener('click',function(){
          var nm=(document.getElementById('alxLdName').value||'').trim();
          var ph=(document.getElementById('alxLdPhone').value||'').replace(/\D/g,'');
          var em=(document.getElementById('alxLdEmail').value||'').trim();
          var err=w.querySelector('.alx-sp-err');
          var msg='';
          if(nm.length<2)msg='Please enter your name';
          else if(ph.length<10)msg='Please enter a valid WhatsApp number';
          else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em))msg='Please enter a valid email';
          if(msg){err.textContent=msg;err.hidden=false;return;}
          err.hidden=true;
          try{localStorage.setItem('alx_lead','1');}catch(e){}
          saveLeadToCart(nm,ph,em);
          saveLeadToCustomers(nm,ph,em);
          s3.innerHTML='<div class="alx-pop-g">🎉</div><h3>You\'re In!</h3>'
            +'<p><b>FREE Delivery</b> is yours on orders above <b>Rs.6,000</b> — applied automatically at checkout. No code needed 💜</p>'
            +'<a class="alx-pop-btn" href="/collections/all">Start Shopping</a>';
          s1.hidden=true;s3.hidden=false;
          setTimeout(close,6000);
        });
      }catch(e){}
    },5000);
  }catch(e){}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initPromo);}else{initPromo();}
})();
